//bao migrate skip
import "./../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
//class ReminderTicketHistoryDialog  extends BaseDialog{
//    constructor(tabPage : Factories.TabPage) {
//        super(tabPage);
//    }
//    Bao = Bao;
//    Sorting = ko.observable();
//    selectedModel = ko.observable();
//    Models = ko.observableArray();
//}
//export = ReminderTicketHistoryDialog;
class ReminderTicketHistoryDialog {
    constructor(ticketId: string, dialog: BaoDialog) {
        this.Dialog = dialog;
        //$.extend(this, data);        
        this.TicketId(ticketId);
    }
    Bao = Bao;
    Dialog: BaoDialog;
    Sorting = ko.observable();
    SelectionModelRows = ko.observableArray<any>([]);
    selectedModel = ko.observable();
    Models = ko.observableArray();
    TicketId = ko.observable();
    selected = ko.observable();
    GetModels(id) {
        Bao.post("ReminderTicket/GetReminderTicketHistory", JSON.stringify({
            ticketId: id
        }), ((result) => {
            this.Models(result);
        }));
    }
    Init() {
        Bao.post("ReminderTicket/GetReminderTicketHistory", JSON.stringify({
            ticketId: this.TicketId()
        }), ((result) => {
            this.Models(result);
        }));
    }
    loaded() {
    }
}
export default ReminderTicketHistoryDialog;